import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M5.22182 3.22239L5.92893 2.51529L4.51472 1.10107L3.80761 1.80818C-0.732993 6.34879 -1.21257 13.4126 2.36888 18.4862L0.497831 18.4865L0.498152 20.4865L6.19787 20.4858L6.19787 15.5006H4.19787L4.19787 17.6C0.958594 13.2909 1.29991 7.14431 5.22182 3.22239Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.97413 4.63763C6.89318 5.26171 6.52283 6.64391 7.14691 7.72485L11.1787 14.7082L8.59641 15.5885C7.87729 15.8337 7.37667 16.4879 7.32799 17.2461L7.21825 18.9551L13.7363 21.6481C14.5276 21.975 15.4259 21.9157 16.1674 21.4877L22.3036 17.9449C23.3314 17.3515 23.8641 16.167 23.6259 15.0043L22.4943 9.47943C22.2325 8.20158 21.111 7.28206 19.8067 7.27587L15.6098 7.25597C15.1214 7.25365 14.6412 7.3811 14.2183 7.62527L12.7861 8.45217L11.0613 5.46485C10.4373 4.38391 9.05507 4.01355 7.97413 4.63763Z"}}]};

const GestureWipeDownFilled = Vue.extend<IconProps>({
  name: 'GestureWipeDownFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'gesture-wipe-down-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default GestureWipeDownFilled;
